var map = {
	"./서브2_공제어감각.svg": "9ecc",
	"./서브2_시야.svg": "ba20",
	"./서브2_체력.svg": "7fc3",
	"./서브2_키.svg": "ad4f",
	"./서브2_패스킥슛.svg": "20d0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a489";